<template>
  <v-row>
    <v-col cols="12">
      <v-sheet
        width="100%"
        outlined
        min-height="180px"
      >
        <v-row>
          <v-col cols="12" class="pa-8">
            <v-btn 
              :to="{ name: 'newSponsorEdition', params: { edition_id: this.edition_id, types_sponsor_id: this.types_sponsor_id } }"
              color="primary">
              Nuevo Sponsor
            </v-btn>
          </v-col>

          <v-col cols="12" class="pa-8">
            <label><b>Tipo de Sponsor:</b> {{ type_sponsor.name }}</label>
          </v-col>
          
          <v-col cols="12">
            <v-data-table
              class="pt-8"
              :headers="headers"
              :items="sponsors"
              :custom-filter="customSearch"
              :items-per-page="30"
              :header-props="headerProps"
              :footer-props="{
                'items-per-page-options': [10, 20, 30, 40, 50, 100],
                'items-per-page-text':'Sponsors por página',
              }"
              mobile="true"
            >
              <template v-slot:item.actions="{ item }">
                <td class="text-center">

                  <v-btn
                    class="mx-2"
                    fab
                    dark
                    x-small
                    outlined
                    color="black"
                    @click="moveUp(item.id)"
                  >
                    <v-icon dark small>
                      mdi-arrow-up
                    </v-icon>
                  </v-btn>
                  <v-btn
                    class="mx-2"
                    fab
                    dark
                    x-small
                    outlined
                    color="black"
                    @click="moveDown(item.id)"
                  >
                    <v-icon dark small>
                      mdi-arrow-down
                    </v-icon>
                  </v-btn>

                  <v-btn
                    class="mx-2"
                    fab
                    dark
                    x-small
                    color="primary"
                    :to="{ name: 'showSponsorEdition', params: {edition_id: edition_id, types_sponsor_id: types_sponsor_id, sponsor_id: item.id } }"

                  >
                    <v-icon dark small>
                      mdi-eye
                    </v-icon>
                  </v-btn>

                  <v-btn
                    class="mx-2"
                    fab
                    dark
                    x-small
                    color="warning"
                    :to="{ name: 'editSponsorsEdition', params: {edition_id: edition_id, types_sponsor_id: types_sponsor_id, sponsor_id: item.id } }"
                  >
                    <v-icon small>
                      mdi-pencil
                    </v-icon>
                  </v-btn>

                  <v-btn
                    class="mx-2"
                    fab
                    dark
                    x-small
                    color="red"
                    @click="confirmDeleteSponsor(item.id)"
                  >
                    <v-icon dark small>
                      mdi-close
                    </v-icon>
                  </v-btn>
                </td>
              </template>
            </v-data-table>
          </v-col>

        </v-row>
      </v-sheet>
    </v-col>
   
    <v-col cols="12" class="pt-2 d-flex justify-space-between">
      <v-btn
        depressed
        color="primary"
        :to="{ name: 'typeSponsorsEdition', params: { edition_id:this.edition_id, types_sponsor_id: this.types_sponsor_id }}"
        >
        <v-icon left>
          mdi-arrow-left
        </v-icon>
        Volver
      </v-btn>

      <v-btn
        depressed
        color="primary"
        :to="{ name: 'showSponsorsEdition', params: { edition_id:this.edition_id, types_sponsor_id: this.types_sponsor_id }}"
        >
        <v-icon left>
          mdi-eye
        </v-icon>
        Vista previa
      </v-btn>
    </v-col>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog_delete"
      width="500"
    >
      <v-card>
        <v-card-title class="text-h5 lighten-2">
          Atención 
        </v-card-title>

        <v-card-text class="pt-4 pb-6">
          ¿Está seguro que desea borrar esta edición? Toda la información
          vinculada a los emprendimientos y emprendedores se borrara tambíen.
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialog_delete = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            text
            :loading="loading_btn"
            @click="deleteSponsor"
          >
            Borrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'sponsorsEdition',

    data: () => ({
      show:false,
      loading:true,
      loading_btn: false,
      
      dialog_delete:false,
      delete_id:null,
      name:'',

      edition_id: null,
      types_sponsor_id: null,
      Edition:false,

      sponsors:[],
      type_sponsor:[],

      headerProps: {
        sortByText: "Ordenar por"
      },
      headers: [
      {
          text: '#',
          align: 'start',
          sortable: true,
          value: 'order',
          width: '5%'
        },
        {
          text: 'Patrocinador',
          align: 'start',
          sortable: true,
          value: 'name',
          width: '65%'
        },
        {
          text: 'Acciones',
          align: 'center',
          sortable: false,
          value: 'actions',
          width: '35%'
        }
      ],
      attrs: {
        boilerplate: false,
      },
    }),

    methods:{
      customSearch (value, search, item) {
          return Object.values(item).some(v=>v&&v.toString().toLowerCase().includes(search))
      },
      
      filterOnlyCapsText (value, search, item) {
        console.log(item)
        return value != null &&
          search != null &&
          typeof value === 'string' &&
          value.toString().toLocaleUpperCase().indexOf(search) !== -1
      },

      async getSponsors()
      {
        await axios.get('admin/editions/'+this.edition_id+'/types-sponsors/'+this.types_sponsor_id+'/sponsors').then(response =>{
          this.type_sponsor = response.data.data.type_sponsor
          this.sponsors = response.data.data.sponsors
          this.loading=false
          this.show=true
        }).catch(error => {
          console.log(error);
        })
      },

      confirmDeleteSponsor(id)
      {
        this.dialog_delete = true
        this.delete_id = id
      },

      async deleteSponsor()
      {
        this.loading_btn = true
        try {  
          await axios.delete('admin/editions/'+this.edition_id+'/types-sponsors/'+this.types_sponsor_id+'/sponsors/'+this.delete_id).then(() =>{
            this.dialog_delete = false
            this.loading_btn =false
            this.loading=true
            this.delete_id = null
            this.loading = true
            this.getSponsors()
          })
        } catch (error) {
          console.error(error.response.data);
        }
      },

      async moveUp(id){
        this.loading = true
        try{
          await axios.put('admin/editions/'+this.edition_id+'/types-sponsors/'+this.types_sponsor_id+'/sponsors/'+id+'/move-up', {
            edition_id: this.edition_id
          }).then(()=>{
            this.getSponsors()
          })
        }catch(error) {
          this.loading = false
          console.log(error)
        }
      },
      
      async moveDown(id){
        this.loading = true
        try{
          await axios.put('admin/editions/'+this.edition_id+'/types-sponsors/'+this.types_sponsor_id+'/sponsors/'+id+'/move-down', {
            edition_id: this.edition_id
          }).then(()=>{
            this.getSponsors()
          })
        }catch(error) {
          this.loading = false
          console.log(error)
        }
      }
    },

    created(){
      this.edition_id = this.$route.params.edition_id
      this.types_sponsor_id = this.$route.params.types_sponsor_id
      
      this.getSponsors()
    },
  }
</script>
